import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AddOnsFilter } from "./SupplementsForDishesPage";
import i18next from "i18next";
import { ErrorModalComponent } from "@me-pos/error-modal";

interface SupplementsForDishesFiltersProps {
    setFilters: React.Dispatch<React.SetStateAction<AddOnsFilter>>;
}

const SupplementsForDishesFilters: React.FC<SupplementsForDishesFiltersProps> = ({ setFilters }) => {
    const { t } = useTranslation();
    const [search, setSearch] = useState("");
    const [isErrorModalOpen, setIsErrorModalOpen] = useState<number>(null);

    const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            handleApplyFilter();
        }
    };

    const handleApplyFilter = () => {
        setFilters({ search: "" });
        setFilters({ search: search ? search.trim() : "" });
    };

    const handleClearFilter = () => {
        setFilters({ search: null });
        setSearch("");
    };

    return (
        <>
            <Row className="gx-4 pb-6">
                <Col lg={8} xl={9}>
                    <Row className="gx-3">
                        <Col className="mb-3 mb-lg-0">
                            <div className="position-relative">
                                <input
                                    type="text"
                                    id={"addOns-name-field"}
                                    className="form-control rounded-1 pe-7"
                                    placeholder={t("Search by group name and options")}
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value.trimStart())}
                                    onBlur={(e) => setSearch(e.target.value.trim())}
                                    onKeyDown={handleSearchKeyDown}
                                />
                                <i className="bi bi-search position-absolute top-50 end-0 translate-middle-y text-dark me-3"></i>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col lg={4} xl={3}>
                    <Row className="gx-3 h-100">
                        <Col xs={6} className="mb-3 mb-lg-0">
                            <Button
                                variant="outline-dark"
                                className="border-grey w-100 h-100 fw-normal"
                                onClick={handleClearFilter}
                            >
                                {t("clear")}
                            </Button>
                        </Col>
                        <Col xs={6} className="mb-3 mb-lg-0">
                            <Button variant="primary" className="w-100 h-100 px-1" onClick={handleApplyFilter}>
                                {t("Apply")}
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            {isErrorModalOpen ? (
                <ErrorModalComponent
                    i18n={i18next}
                    onClose={() => {
                        setIsErrorModalOpen(null);
                    }}
                    isOpen={!!isErrorModalOpen}
                    currentError={isErrorModalOpen}
                />
            ) : null}
        </>
    );
};

export default SupplementsForDishesFilters;
